interface IcardContacts {
    title: string,
    text:string,
    button: string
}

export const CardContacts = ({title, text, button}:IcardContacts) => {

    return (
    <article className="p-5">
        <div className="md:flex md:flex-col flex flex-col md:justify-center items-center gap-y-4 text-start fontText">
            <p className="text-2xl font-bold text-white">{title}</p>
            <p className="md:text-sm text-gray-400">{text}</p>
            
            <a href="https://bio.site/JeanTech" target="_blank" rel="noreferrer">
                <button className="bg-red-600 rounded-md md:w-[8vw] w-[18vw] p-2 border ">{button}</button>
            </a>
        </div>
    </article>
)
}